import Handlebars from 'handlebars';
import i18n from '../i18n';

import { constants, helpers } from './handlebars.helpers';

i18n.then( () => Object.keys( helpers )
    .forEach( key => {
        // allow to name block-level helpers with "#" in the beginning
        const helperName = key.startsWith( '#' )
            ? key.substr( 1 )
            : key;

        Handlebars.registerHelper( helperName, helpers[key] );
    } ) );

export default Handlebars;


// WEBPACK FOOTER //
// ./src/js/lib/handlebars.js